export default __webpack_public_path__ + "static/media/manifoldjs.bcf6fa73.svg";